import { ErrorMessage } from "formik"

export const Label = ({ lbl, field, trigger = true }) => {
    return (
        <div className="flex justify-between flex-wrap">
            <label htmlFor="" className="block text-sm font-medium text-white">
                {lbl}
            </label>
            {trigger && <ErrorMessage name={field} component="p" className="text-sm font-semibold text-secundario" />}
        </div>
    )
}